(() => {
  // =====================================
  // FLITE Configurator (Landing)
  // - Prezzi mostrati IVA inclusa (22%)
  // - Sconto (PIN) applicato SOLO al prezzo base (non accessori)
  // - Preventivo stampato con QR WhatsApp
  // =====================================

  // =========================
  // HELPERS
  // =========================
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const norm = (s) => (s || "").toString().trim().toLowerCase();
  const clamp = (n, a, b) => Math.min(b, Math.max(a, n));

  const money = (cents) =>
    (Number(cents) / 100).toLocaleString("it-IT", { style: "currency", currency: "EUR" });

  const todayStr = () => {
    const d = new Date();
    return d.toLocaleDateString("it-IT", { year: "numeric", month: "2-digit", day: "2-digit" });
  };

  const pad2 = (n) => String(n).padStart(2, "0");
  const nowStamp = () => {
    const d = new Date();
    return `${d.getFullYear()}${pad2(d.getMonth() + 1)}${pad2(d.getDate())}-${pad2(
      d.getHours()
    )}${pad2(d.getMinutes())}${pad2(d.getSeconds())}`;
  };
  const quoteCode = () => `PM-${nowStamp()}`;

  // =========================
  // PRICING
  // =========================
  const VAT_RATE = 0.22; // Italia
  const euroNetToGrossCents = (netEuro) => {
    const net = Number(netEuro);
    if (!Number.isFinite(net)) return 0;
    return Math.round(net * 100 * (1 + VAT_RATE));
  };

  // =========================
  // STATIC DATA (da Flite EU: prezzi escludono tasse)
  // Nota: qui usiamo i "starting price" per la landing.
  // =========================
  const MODELS = [
    {
      id: "icon",
      label: "FLITE ICON",
      subtitle: "Beginner – Intermediate",
      variants: [
        // Carbon (3 colori)
        {
          key: "carbon-ash",
          title: "Carbon · Ash",
          desc: "Carbon leggero e reattivo (colore Ash).",
          netEuro: 12627,
        },
        {
          key: "carbon-black",
          title: "Carbon · Black",
          desc: "Carbon leggero e reattivo (colore Black).",
          netEuro: 12627,
        },
        {
          key: "carbon-jade",
          title: "Carbon · Jade",
          desc: "Carbon leggero e reattivo (colore Jade).",
          netEuro: 12627,
        },

        // Soft Top 2 (2 colori)
        {
          key: "soft-top-2-saltbush",
          title: "Soft Top 2 · Saltbush",
          desc: "Massima durabilità e comfort (Saltbush).",
          netEuro: 10919,
        },
        {
          key: "soft-top-2-sky",
          title: "Soft Top 2 · Sky",
          desc: "Massima durabilità e comfort (Sky).",
          netEuro: 10919,
        },

        // Fiberglass
        {
          key: "fibreglass-white",
          title: "Fibreglass · White",
          desc: "Equilibrio perfetto tra prestazioni e robustezza (White).",
          netEuro: 10919,
        },
      ],
    },
    {
      id: "pro-s5",
      label: "FLITE PRO S5",
      subtitle: "Intermediate – Advanced",
      variants: [
        // Carbon (4 colori)
        {
          key: "carbon-ash",
          title: "Carbon · Ash",
          desc: "Performance e risposta premium (Ash).",
          netEuro: 12627,
        },
        {
          key: "carbon-black",
          title: "Carbon · Black",
          desc: "Performance e risposta premium (Black).",
          netEuro: 12627,
        },
        {
          key: "carbon-jade",
          title: "Carbon · Jade",
          desc: "Performance e risposta premium (Jade).",
          netEuro: 12627,
        },
        {
          key: "carbon-ultramarine",
          title: "Carbon · Ultramarine",
          desc: "Performance e risposta premium (Ultramarine).",
          netEuro: 12627,
        },

        // Soft Top 2 (3 colori)
        {
          key: "soft-top-2-saltbush",
          title: "Soft Top 2 · Saltbush",
          desc: "Controllo + sicurezza sotto i piedi (Saltbush).",
          netEuro: 10919,
        },
        {
          key: "soft-top-2-sky",
          title: "Soft Top 2 · Sky",
          desc: "Controllo + sicurezza sotto i piedi (Sky).",
          netEuro: 10919,
        },
        {
          key: "soft-top-2-sol",
          title: "Soft Top 2 · Sol",
          desc: "Controllo + sicurezza sotto i piedi (Sol).",
          netEuro: 10919,
        },

        // Fiberglass
        {
          key: "fibreglass-white",
          title: "Fibreglass · White",
          desc: "Setup versatile per riding dinamico (White).",
          netEuro: 10919,
        },
      ],
    },
    {
      id: "ultra-l3",
      label: "FLITE ULTRA L3",
      subtitle: "Advanced",
      variants: [
        {
          key: "mn-carbon-prop-c-folding",
          title: "MN Carbon Prop C · Folding Prop",
          desc: "Setup Ultra L3 con MN Carbon Prop C e folding prop.",
          netEuro: 14640,
        },
        {
          key: "mn-carbon-wave-c",
          title: "MN Carbon Wave C",
          desc: "Setup Ultra L3 con MN Carbon Wave C.",
          netEuro: 14640,
        },
        {
          key: "prop-c-folding",
          title: "Prop C · Folding Prop",
          desc: "Setup Ultra L3 con Prop C e folding prop.",
          netEuro: 14640,
        },
      ],
    },
    {
      id: "air",
      label: "FLITE AIR",
      subtitle: "Beginner – Intermediate",
      variants: [
        {
          key: "air-icon",
          title: "AIR · Icon",
          desc: "AIR Icon: gonfiabile rivoluzionario, durabilità e divertimento.",
          netEuro: 8967,
        },
        {
          key: "air-pro",
          title: "AIR · Pro",
          desc: "AIR Pro: feeling più sportivo.",
          netEuro: 8967,
        },
      ],
    },
    {
      id: "flitescooter",
      label: "FLITESCOOTER",
      subtitle: "Beginner",
      variants: [
        {
          key: "flitescooter-sky",
          title: "Flitescooter · Sky",
          desc: "Impari in pochi minuti: step on & go.",
          netEuro: 10919,
        },
      ],
    },
  ];

  // =========================
  // IMMAGINI PER CONFIGURAZIONE (model + variant)
  // Se manca una combinazione, si usa fallback da Liquid (data-img-*)
  // =========================
  const MODEL_VARIANT_IMAGES = {
    icon: {
      "carbon-ash": "https://eu.fliteboard.com/cdn/shop/files/Carbon_Icon_Ash_J2-S80_CJ1500.png?v=1768385755",
      "carbon-black": "https://eu.fliteboard.com/cdn/shop/files/Carbon_Icon_Black_J2-B80_CJ1500.png?v=1768385755",
      "carbon-jade": "https://eu.fliteboard.com/cdn/shop/files/Carbon_Icon_Jade_J2-B80_CJ1500.png?v=1768385755",
      "soft-top-2-saltbush": "https://eu.fliteboard.com/cdn/shop/files/ST2_Icon_Saltbush_J2-B80_CJ1500.png?v=1768385742",
      "soft-top-2-sky": "https://eu.fliteboard.com/cdn/shop/files/ST2_Icon_Sky_J2-B80_CJ1500.png?v=1768385742",
      "fibreglass-white": "https://eu.fliteboard.com/cdn/shop/files/Fiberglass_Icon_White_J2-S80_CJ1500_850adee9-dcdc-48ee-9609-6cae713b8828.png?v=1768385726",
    },
    "pro-s5": {
      "carbon-ash": "https://eu.fliteboard.com/cdn/shop/files/Carbon_Pro_Ash_J2-S80_MN1300.png?v=1768385760",
      "carbon-black": "https://eu.fliteboard.com/cdn/shop/files/Carbon_Pro_Black_J2-B80_MN1300.png?v=1768385759",
      "carbon-jade": "https://eu.fliteboard.com/cdn/shop/files/Carbon_Pro_Jade_J2-B80_MN1300.png?v=1768385759",
      "carbon-ultramarine": "https://eu.fliteboard.com/cdn/shop/files/Carbon_Pro_Ultramarine_J2-B80_MN1300.png?v=1768385759",
      "soft-top-2-saltbush": "https://eu.fliteboard.com/cdn/shop/files/ST2_Pro_Saltbush_J2-B80_MN1300.webp?v=1768386155",
      "soft-top-2-sky": "https://eu.fliteboard.com/cdn/shop/files/ST2_Pro_Sky_J2-B80_MN1300.png?v=1768385735",
      "soft-top-2-sol": "https://eu.fliteboard.com/cdn/shop/files/ST2_Pro_Sol_J2-B80_MN1300.png?v=1768385737",
      "fibreglass-white": "https://eu.fliteboard.com/cdn/shop/files/Fibreglass_Pro_White_J2-S80_MN1300.png?v=1768385722",
    },
    "ultra-l3": {
      "mn-carbon-prop-c-folding": "https://eu.fliteboard.com/cdn/shop/files/ULTRA_L3_Carbon_82_Flite_folding_prop_Flux_1010_245.webp?v=1768447981",
      "mn-carbon-wave-c": "https://eu.fliteboard.com/cdn/shop/files/Ultra_L3_Ultramarine_FP-MNWave_F1010_160.png?v=1768385735",
      "prop-c-folding": "https://eu.fliteboard.com/cdn/shop/files/ULTRA_L3_black_80cm_Flite_folding_prop_Flux_1010_245.webp?v=1768448025",
    },
    air: {
      "air-icon": "https://eu.fliteboard.com/cdn/shop/files/AIR_Icon_Sabbia_J2-B80_CJ1500.png?v=1768385726",
      "air-pro": "https://eu.fliteboard.com/cdn/shop/files/AIR_PRO_Sabbia_J2-B80_MN1300.png?v=1768385716",
    },
    flitescooter: {
      "flitescooter-sky": "https://eu.fliteboard.com/cdn/shop/files/Flitescooter_Sky_J2-B65_C1800.webp?v=1768385715",
    },
  };

  // Extra selezionabili per preventivo (senza sconto)
  // Prezzi base da Fliteboard EU (assunti IVA esclusa). Qui vengono mostrati IVA 22% inclusa.
  // NOTA: per ogni modello mostriamo una lista diversa di extra (stile configuratore Flite).

  const ACCESSORY_CATALOG = [
    {
      id: "flitecell-nano",
      category: "Batteria",
      title: "Flitecell Nano",
      desc: "Batteria compatta e leggera.",
      netEuro: 2440,
      img: "https://eu.fliteboard.com/cdn/shop/files/Flitecell_Nano_Battery_800x.png?v=1745366119",
    },
    {
      id: "flitecell-sport",
      category: "Batteria",
      title: "Flitecell Sport",
      desc: "Batteria standard: equilibrio tra autonomia e performance.",
      netEuro: 2806,
      img: "https://eu.fliteboard.com/cdn/shop/files/Flitecell_Sport_Battery_800x.png?v=1745366119",
    },
    {
      id: "flitecell-explore",
      category: "Batteria",
      title: "Flitecell Explore",
      desc: "Massima autonomia per sessioni lunghe.",
      netEuro: 4026,
      img: "https://eu.fliteboard.com/cdn/shop/files/Flitecell_Explore_Battery_800x.png?v=1745366119",
    },
    {
      id: "charger-fast",
      category: "Caricabatterie",
      title: "Fast Charger",
      desc: "Caricatore rapido.",
      netEuro: 1159,
      img: "https://eu.fliteboard.com/cdn/shop/files/fast_charger_800x.png?v=1745366118",
    },
    {
      id: "charger-slow",
      category: "Caricabatterie",
      title: "Slow Charger",
      desc: "Caricatore standard.",
      netEuro: 268.4,
      img: "https://eu.fliteboard.com/cdn/shop/files/slow_charger_800x.png?v=1745366118",
    },
  ];

  // Quali extra mostrare per ogni configuratore/modello
  // (coerente con l'idea che ogni tavola abbia la sua "tavola" accessori)
  const ACCESSORIES_BY_MODEL = {
    icon: ["flitecell-nano", "flitecell-sport", "charger-fast"],
    "pro-s5": ["flitecell-sport", "flitecell-explore", "charger-fast"],
    "ultra-l3": ["flitecell-explore", "charger-fast", "charger-slow"],
    air: ["flitecell-nano", "flitecell-sport", "charger-slow"],
    flitescooter: ["flitecell-nano", "charger-slow"],
  };

  const ACCESSORY_CATALOG_GROSS = ACCESSORY_CATALOG.map((x) => ({
    ...x,
    grossCents: euroNetToGrossCents(x.netEuro),
  }));

  const buildAccessoriesForModel = (modelId) => {
    // ICON: la configurazione usa Step 4 (Flitecell) + Step 5 (Charger), quindi qui non mostriamo extra.
    if (modelId === "icon") return [];
    const ids = ACCESSORIES_BY_MODEL[modelId] || [];
    const list = ids
      .map((id) => ACCESSORY_CATALOG_GROSS.find((a) => a.id === id))
      .filter(Boolean)
      .map((a) => ({ ...a, checked: false }));
    return list;
  };

  // =========================
  // ICON STEP DATA + HELPERS
  // =========================
  // ICON: vertical stepper data
  const ICON_STEPS = {
    step1Model: {
      title: "Step 1 · Modello",
      hint: "Scegli la tavola",
      options: [
        {
          id: "carbon",
          label: "Carbon",
          fromNetEuro: 12627,
          desc: "Leggero, reattivo",
          colors: [
            { id: "ash", label: "Ash" },
            { id: "black", label: "Black" },
            { id: "jade", label: "Jade" },
          ],
        },
        {
          id: "soft-top-2",
          label: "Soft Top 2",
          fromNetEuro: 10919,
          desc: "Massima durabilità, comfort",
          colors: [
            { id: "saltbush", label: "Saltbush" },
            { id: "sky", label: "Sky" },
          ],
        },
        {
          id: "fibreglass",
          label: "Fibreglass",
          fromNetEuro: 10919,
          desc: "Equilibrio prestazioni/robustezza",
          colors: [
            { id: "white", label: "White" },
          ],
        },
      ],
    },
    step3Efoil: {
      title: "Step 3 · Efoil",
      hint: "Seleziona il motore",
      options: [
        {
          id: "j2",
          label: "Jet (J2)",
          deltaNetEuro: 0,
          desc: "Propulsione Jet – sicura per principianti.",
          recommended: true,
        },
        {
          id: "prop-c",
          label: "Prop C",
          deltaNetEuro: 0,
          desc: "Propulsione elica – più efficiente.",
          recommended: false,
        },
      ],
    },
    step4Flitecell: {
      title: "Step 4 · Flitecell",
      hint: "Scegli la batteria",
      options: [
        {
          id: "nano",
          label: "Nano",
          deltaNetEuro: 0,
          desc: "Compatta e leggera.",
          recommended: false,
        },
        {
          id: "sport",
          label: "Sport",
          deltaNetEuro: 366,
          desc: "Equilibrio autonomia/performance.",
          recommended: true,
        },
      ],
    },
    step5Charger: {
      title: "Step 5 · Caricabatterie",
      hint: "Scegli il caricatore",
      options: [
        {
          id: "fast",
          label: "Fast Charger",
          deltaNetEuro: 0,
          desc: "Caricatore rapido incluso.",
          recommended: true,
        },
      ],
    },
  };

  // ICON: default selection state
  function iconDefaultSelection() {
    return {
      model: ICON_STEPS.step1Model.options[0].id,
      color: ICON_STEPS.step1Model.options[0].colors[0].id,
      efoil: ICON_STEPS.step3Efoil.options[0].id,
      flitecell: ICON_STEPS.step4Flitecell.options[0].id,
      charger: ICON_STEPS.step5Charger.options[0].id,
    };
  }

  // ICON: find model option by id
  function findIconModel(modelId) {
    return ICON_STEPS.step1Model.options.find((o) => o.id === modelId);
  }

  // ICON: find color key for variant
  function findIconColorKey(modelId, colorId) {
    if (modelId === "carbon") return `carbon-${colorId}`;
    if (modelId === "soft-top-2") return `soft-top-2-${colorId}`;
    if (modelId === "fibreglass") return `fibreglass-${colorId}`;
    return "";
  }

  // ICON: find option in step by id
  function findIconOption(step, id) {
    return (step.options || []).find((o) => o.id === id);
  }

  // =========================
  // INIT
  // =========================
  document.addEventListener("DOMContentLoaded", () => {
    // Compat: accetta .flite-configurator oppure .seabob-configurator (stesso markup)
    const root = document.querySelector(".flite-configurator") || document.querySelector(".seabob-configurator");
    if (!root) return;

    // CONFIG from data-attributes
    const CONFIG = {
      whatsappNumber: (root.dataset.whatsappNumber || "").replace(/\D/g, "") || "393423488673",
      discountPin: (root.dataset.discountPin || "").trim() || "101026",
      fairValidUntil: root.dataset.fairUntil || "15/02/2026",
    };

    // =========================
    // IMAGES (from Liquid data-attributes)
    // In Liquid wrapper you should have:
    // data-img-icon, data-img-pro-s5, data-img-ultra-l3, data-img-air, data-img-flitescooter
    // =========================
    const pickImg = (v) => {
      if (!v) return "";
      const s = String(v).trim();
      if (!s) return "";
      if (s.toLowerCase() === "disabled") return "";
      return s;
    };

    const getModelImageUrl = (modelId) => {
      if (modelId === "icon") return pickImg(root.dataset.imgIcon);
      if (modelId === "pro-s5") return pickImg(root.dataset.imgProS5);
      if (modelId === "ultra-l3") return pickImg(root.dataset.imgUltraL3);
      if (modelId === "air") return pickImg(root.dataset.imgAir);
      if (modelId === "flitescooter") return pickImg(root.dataset.imgFlitescooter);
      return "";
    };

    const setMainImage = (src) => {
      const img = $("#mainImg", root);
      if (!img) return;
      const s = String(src || "").trim();
      if (!s) return;
      img.setAttribute("src", s);
    };

    const updateMainImageForSelection = () => {
      const modelId = state.modelId;
      const variantKey = state.variantKey;

      // 1) Try per-variant image
      const map = MODEL_VARIANT_IMAGES[modelId];
      const perVariant = map ? map[variantKey] : "";
      if (perVariant) {
        setMainImage(perVariant);
        return;
      }

      // 2) Fallback: per-model image from Liquid
      const url = getModelImageUrl(modelId);
      if (url) setMainImage(url);
    };

    const state = {
      modelId: MODELS[0]?.id || "icon",
      variantKey: MODELS[0]?.variants?.[0]?.key || "carbon-ash",
      iconSel: iconDefaultSelection(),
      accessories: buildAccessoriesForModel(MODELS[0]?.id || "icon"),
      discount: { unlockedUntil: 0, mode: "percent", value: 0 }, // % oppure fixed(€)
    };

    // =========================
    // MODEL + VARIANT HELPERS
    // =========================
    const currentModel = () => MODELS.find((m) => m.id === state.modelId) || MODELS[0];
    const currentVariant = () => {
      const m = currentModel();

      // ICON: derive variantKey from Step 1 (model) + Step 2 (color)
      if (state.modelId === "icon") {
        const key = findIconColorKey(state.iconSel.model, state.iconSel.color);
        state.variantKey = key;
      }

      return (m.variants || []).find((v) => v.key === state.variantKey) || (m.variants || [])[0];
    };

    const baseGrossCents = () => {
      // ICON: base price = “From” della costruzione (Step 1)
      if (state.modelId === "icon") {
        const m1 = findIconModel(state.iconSel.model);
        return euroNetToGrossCents(m1?.fromNetEuro || 0);
      }

      const v = currentVariant();
      return euroNetToGrossCents(v?.netEuro || 0);
    };

    const computeDiscountCents = (baseCents) => {
      const unlocked = Date.now() < (state.discount?.unlockedUntil || 0);
      if (!unlocked) return 0;

      const base = Math.max(0, Number(baseCents || 0));
      const val = Math.max(0, Number(state.discount?.value || 0));

      let dc = 0;
      if (state.discount?.mode === "fixed") {
        dc = Math.round(val * 100); // € -> cents
      } else {
        const pct = clamp(val, 0, 100);
        dc = Math.round(base * (pct / 100));
      }
      return Math.min(base, Math.max(0, dc));
    };

    const computeTotalCentsOriginal = () => {
      let total = baseGrossCents();
      // ICON: add-on del configuratore (non accessori)
      if (state.modelId === "icon") {
        const e = findIconOption(ICON_STEPS.step3Efoil, state.iconSel.efoil);
        const b = findIconOption(ICON_STEPS.step4Flitecell, state.iconSel.flitecell);
        const c = findIconOption(ICON_STEPS.step5Charger, state.iconSel.charger);
        total += euroNetToGrossCents(e?.deltaNetEuro || 0);
        total += euroNetToGrossCents(b?.deltaNetEuro || 0);
        total += euroNetToGrossCents(c?.deltaNetEuro || 0);
      }
      state.accessories
        .filter((a) => a.checked)
        .forEach((a) => {
          if (typeof a.grossCents === "number") total += a.grossCents;
        });
      return total;
    };

    const computeTotalCents = () => {
      const base = baseGrossCents();
      const disc = computeDiscountCents(base);
      const baseAfter = Math.max(0, base - disc);

      let total = baseAfter;
      // ICON: add-on del configuratore (non accessori)
      if (state.modelId === "icon") {
        const e = findIconOption(ICON_STEPS.step3Efoil, state.iconSel.efoil);
        const b = findIconOption(ICON_STEPS.step4Flitecell, state.iconSel.flitecell);
        const c = findIconOption(ICON_STEPS.step5Charger, state.iconSel.charger);
        total += euroNetToGrossCents(e?.deltaNetEuro || 0);
        total += euroNetToGrossCents(b?.deltaNetEuro || 0);
        total += euroNetToGrossCents(c?.deltaNetEuro || 0);
      }
      state.accessories
        .filter((a) => a.checked)
        .forEach((a) => {
          if (typeof a.grossCents === "number") total += a.grossCents;
        });
      return total;
    };

    // =========================
    // UI: WhatsApp
    // =========================
    const whatsappLink = () => {
      const base = `https://wa.me/${CONFIG.whatsappNumber}`;
      const m = currentModel();
      const v = currentVariant();

      const selectedAcc = state.accessories.filter((a) => a.checked).map((a) => a.title);
      const accText = selectedAcc.length ? `\nExtra: ${selectedAcc.join(", ")}` : "";

      const totalText = `\nTotale (IVA incl.): ${money(computeTotalCents())}`;

      const text = encodeURIComponent(
        `Ciao! Vorrei un preventivo per ${m.label}\n` +
          `Configurazione: ${v.title}\n` +
          `Prezzo base (IVA incl.): ${money(baseGrossCents())}` +
          `${accText}${totalText}\n` +
          `Validità fiera: fino al ${CONFIG.fairValidUntil}.`
      );

      return `${base}?text=${text}`;
    };

    // =========================
    // RENDER
    // =========================
    function renderModelCards() {
      // Se esistono card statiche nel markup (come SEABOB), le aggiorniamo.
      // Altrimenti generiamo dentro #modelGrid.
      const grid = $("#modelGrid", root);
      if (!grid) return;

      let cards = $$(".modelCard", grid);
      if (!cards.length) {
        // Generate cards
        grid.innerHTML = MODELS.map(
          (m) => `
            <div class="modelCard" data-model="${m.id}" role="button" tabindex="0">
              <div class="name">${m.label}</div>
              <div class="desc">${m.subtitle}</div>
              <div class="price" data-price="${m.id}">—</div>
            </div>
          `
        ).join("");
        cards = $$(".modelCard", grid);
      }

      cards.forEach((card) => {
        const id = card.dataset.model || card.dataset.price || "";
        const m = MODELS.find((x) => x.id === id);
        const first = m?.variants?.[0];
        const priceEl = $(".price", card) || card.querySelector(`[data-price="${id}"]`);
        if (priceEl && first) priceEl.textContent = `Da ${money(euroNetToGrossCents(first.netEuro))}`;

        card.dataset.active = id === state.modelId ? "true" : "false";
      });

      // events
      cards.forEach((card) => {
        const id = card.dataset.model || "";
        if (!id) return;

        // avoid double binding
        if (card.dataset.bound === "1") return;
        card.dataset.bound = "1";

        card.addEventListener("click", () => selectModel(id));
        card.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") selectModel(id);
        });
      });
    }

    function swatchDotColor(label) {
      const s = norm(label);

      // Carbon palette
      if (s.includes("ash")) return "#5b5b5b";
      if (s.includes("black")) return "#111111";
      if (s.includes("jade")) return "#2ecc71";
      if (s.includes("ultramarine")) return "#2e86de";

      // Soft Top palette
      if (s.includes("saltbush")) return "#c8b39a";
      if (s.includes("sky")) return "#86c5ff";
      if (s.includes("sol")) return "#f5c542";

      // Fiberglass / White
      if (s.includes("white")) return "#e6e6e6";

      // Others
      if (s.includes("air")) return "#2e86de";
      if (s.includes("flitescooter")) return "#27ae60";

      return null;
    }

    function renderVariantChoices() {
      const el = $("#swatches", root);
      if (!el) return;

      // ICON: render Step 1–5 blocks
      if (state.modelId === "icon") {
        const mSel = state.iconSel.model;
        const mOpt = findIconModel(mSel);

        // ensure color is valid for selected model
        const validColors = (mOpt.colors || []).map((x) => x.id);
        if (!validColors.includes(state.iconSel.color)) {
          state.iconSel.color = (mOpt.colors || [])[0]?.id || state.iconSel.color;
        }

        const stepBlock = (title, hint, inner) => `
          <div class="stepBlock">
            <div class="stepHead">
              <div class="stepTitle">${title}</div>
              ${hint ? `<div class="stepHint">${hint}</div>` : ""}
            </div>
            <div class="stepChoices">${inner}</div>
          </div>
        `;

        const btn = ({ active, label, sub, dot, recommended }) => `
          <button type="button" class="swatch swatchStep" data-active="${active ? "true" : "false"}">
            <span class="dot" aria-hidden="true" style="${dot ? `background:${dot};` : ""}"></span>
            <span class="swatchLabel">${label}</span>
            ${recommended ? `<span class="swatchBadge">Consigliato</span>` : ""}
            ${sub ? `<span class="swatchSub">${sub}</span>` : ""}
          </button>
        `;

        // Step 1
        const step1Html = ICON_STEPS.step1Model.options
          .map((o) => {
            const active = o.id === state.iconSel.model;
            const sub = `Da ${money(euroNetToGrossCents(o.fromNetEuro))} · ${o.desc}`;
            return `<div class="stepChoice" data-step="model" data-id="${o.id}">${btn({
              active,
              label: o.label,
              sub,
              dot: swatchDotColor(o.label),
              recommended: false,
            })}</div>`;
          })
          .join("");

        // Step 2 (colors)
        const step2Html = (mOpt.colors || [])
          .map((c) => {
            const active = c.id === state.iconSel.color;
            return `<div class="stepChoice" data-step="color" data-id="${c.id}">${btn({
              active,
              label: c.label,
              sub: "",
              dot: swatchDotColor(c.label),
              recommended: false,
            })}</div>`;
          })
          .join("");

        // Step 3
        const step3Html = ICON_STEPS.step3Efoil.options
          .map((o) => {
            const active = o.id === state.iconSel.efoil;
            const add = o.deltaNetEuro ? `+ ${money(euroNetToGrossCents(o.deltaNetEuro))}` : "Incluso";
            const sub = `${add} · ${o.desc}`;
            return `<div class="stepChoice" data-step="efoil" data-id="${o.id}">${btn({
              active,
              label: o.label,
              sub,
              dot: null,
              recommended: !!o.recommended,
            })}</div>`;
          })
          .join("");

        // Step 4
        const step4Html = ICON_STEPS.step4Flitecell.options
          .map((o) => {
            const active = o.id === state.iconSel.flitecell;
            const add = o.deltaNetEuro ? `+ ${money(euroNetToGrossCents(o.deltaNetEuro))}` : "Incluso";
            const sub = `${add} · ${o.desc}`;
            return `<div class="stepChoice" data-step="flitecell" data-id="${o.id}">${btn({
              active,
              label: o.label,
              sub,
              dot: null,
              recommended: !!o.recommended,
            })}</div>`;
          })
          .join("");

        // Step 5
        const step5Html = ICON_STEPS.step5Charger.options
          .map((o) => {
            const active = o.id === state.iconSel.charger;
            const add = o.deltaNetEuro ? `+ ${money(euroNetToGrossCents(o.deltaNetEuro))}` : "Incluso";
            const sub = `${add} · ${o.desc}`;
            return `<div class="stepChoice" data-step="charger" data-id="${o.id}">${btn({
              active,
              label: o.label,
              sub,
              dot: null,
              recommended: !!o.recommended,
            })}</div>`;
          })
          .join("");

        el.innerHTML =
          stepBlock(ICON_STEPS.step1Model.title, ICON_STEPS.step1Model.hint, step1Html) +
          stepBlock("Step 2 · Colour", "Seleziona colore", step2Html) +
          stepBlock(ICON_STEPS.step3Efoil.title, ICON_STEPS.step3Efoil.hint, step3Html) +
          stepBlock(ICON_STEPS.step4Flitecell.title, ICON_STEPS.step4Flitecell.hint, step4Html) +
          stepBlock(ICON_STEPS.step5Charger.title, ICON_STEPS.step5Charger.hint, step5Html);

        // bind clicks (event delegation: evita effetto “devo cliccare 2 volte” dopo i re-render)
        if (!el.dataset.bound) {
          el.dataset.bound = "1";

          el.addEventListener("click", (e) => {
            const wrap = e.target.closest(".stepChoice");
            if (!wrap || !el.contains(wrap)) return;

            const step = wrap.dataset.step;
            const id = wrap.dataset.id;
            if (!step || !id) return;

            // evita focus/scroll strani su mobile
            e.preventDefault();

            if (step === "model") {
              state.iconSel.model = id;
              const mm = findIconModel(id);
              state.iconSel.color = (mm.colors || [])[0]?.id || state.iconSel.color;
            } else if (step === "color") {
              state.iconSel.color = id;
            } else if (step === "efoil") {
              state.iconSel.efoil = id;
            } else if (step === "flitecell") {
              state.iconSel.flitecell = id;
            } else if (step === "charger") {
              state.iconSel.charger = id;
            }

            // IMPORTANT: aggiorna subito la variantKey ICON, altrimenti la prima UI update usa ancora la key precedente
            state.variantKey = findIconColorKey(state.iconSel.model, state.iconSel.color);

            updateMainImageForSelection();
            renderVariantChoices();
            renderGallery();
            renderSummary();
          });
        }

        return;
      }

      // Default (non-ICON): varianti semplici
      const m = currentModel();
      const variants = m?.variants || [];
      el.innerHTML = "";

      variants.forEach((v) => {
        const b = document.createElement("button");
        b.className = "swatch";
        b.type = "button";
        b.dataset.active = state.variantKey && norm(state.variantKey) === norm(v.key) ? "true" : "false";

        const dot = swatchDotColor(v.title);
        b.innerHTML = `
          <span class="dot" aria-hidden="true" style="${dot ? `background:${dot};` : ""}"></span>
          <span class="swatchLabel">${v.title}</span>
        `;

        b.addEventListener("click", () => selectVariant(v.key));
        el.appendChild(b);
      });
    }

    function renderGallery() {
      // Single-image gallery: main image is controlled by selection.
      // Thumbs are hidden to avoid "doppia scelta".
      const thumbs = $("#thumbs", root);
      if (thumbs) {
        thumbs.innerHTML = "";
        thumbs.style.display = "none";
      }

      updateMainImageForSelection();
    }

    function renderAccessories() {
      const loading = $("#accLoading", root);
      const list = $("#accList", root);
      if (loading) loading.style.display = "none";
      if (!list) return;

      // se non ci sono extra, nascondi tutta la lista
      if (!state.accessories.length) {
        // If this is the "Extra" panel, hide the whole panel for ICON
        const panel = list.closest('.panel');
        if (panel) {
          const title = panel.querySelector('.sectionTitle h2');
          if (title && /extra/i.test(title.textContent)) {
            panel.style.display = 'none';
          }
        }
        list.style.display = "none";
        return;
      }

      list.style.display = "flex";
      list.innerHTML = "";

      state.accessories.forEach((a) => {
        const row = document.createElement("div");
        row.className = "accItem";
        row.classList.toggle("is-selected", !!a.checked);

        row.innerHTML = `
          <div class="accLeft">
            <div class="accImg">${a.img ? `<img src="${a.img}" alt="${a.title}" loading="lazy">` : ""}</div>
            <div class="accMeta">
              <b>${a.title}</b>
              <small>${a.desc || ""}</small>
            </div>
          </div>
          <div class="accRight">
            <div class="priceTag">${money(a.grossCents)}</div>
            <input class="check" type="checkbox" ${a.checked ? "checked" : ""} aria-label="Seleziona ${a.title}">
          </div>
        `;

        const checkbox = row.querySelector(".check");
        row.style.cursor = "pointer";
        row.addEventListener("click", (e) => {
          if (e.target && e.target.classList && e.target.classList.contains("check")) return;
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event("change", { bubbles: true }));
        });

        checkbox.addEventListener("change", () => {
          a.checked = checkbox.checked;
          row.classList.toggle("is-selected", checkbox.checked);
          renderSummary();
        });

        list.appendChild(row);
      });
    }

    function renderSummary() {
      const m = currentModel();
      const v = currentVariant();
      const accCount = state.accessories.filter((a) => a.checked).length;

      const originalCents = computeTotalCentsOriginal();
      const totalCents = computeTotalCents();
      const total = money(totalCents);

      const sumModel = $("#sumModel", root);
      const sumColor = $("#sumColor", root); // riusato come "Configurazione"
      const sumAcc = $("#sumAcc", root);
      const sumTotal = $("#sumTotal", root);

      const qsModel = $("#qsModel", root);
      const qsColor = $("#qsColor", root);
      const qsAcc = $("#qsAcc", root);
      const qsTotal = $("#qsTotal", root);

      const bottomPrice = $("#bottomPrice", root);

      if (sumModel) sumModel.textContent = m?.label || "—";
      if (sumColor) sumColor.textContent = v?.title || "—";
      if (sumAcc) sumAcc.textContent = accCount ? `${accCount} selezionati` : "Nessuno";
      if (sumTotal) sumTotal.textContent = total;

      if (qsModel) qsModel.textContent = m?.label || "—";
      if (qsColor) qsColor.textContent = v?.title || "—";
      if (qsAcc) qsAcc.textContent = accCount ? String(accCount) : "0";
      if (qsTotal) qsTotal.textContent = total;

      if (bottomPrice) bottomPrice.textContent = total;

      // Discount breakdown row (se presente nel markup)
      const meta = $("#discountMeta", root);
      const elOrig = $("#sumOriginal", root);
      const elDisc = $("#sumDiscount", root);
      const showMeta = totalCents < originalCents;

      if (meta) meta.style.display = showMeta ? "flex" : "none";
      if (showMeta) {
        if (elOrig) elOrig.textContent = money(originalCents);
        if (elDisc) elDisc.textContent = "-" + money(originalCents - totalCents);
      }

      const wa1 = $("#ctaWhatsapp", root);
      const wa2 = $("#ctaWhatsappTop", root);
      const link = whatsappLink();
      if (wa1) wa1.href = link;
      if (wa2) wa2.href = link;
    }

    // =========================
    // DISCOUNT UI (se presente nel Liquid)
    // =========================
    function initDiscountUI() {
      const unlockBtn = $("#discountUnlockBtn", root);
      const pinRow = $("#discountPinRow", root);
      const pinInput = $("#discountPinInput", root);
      const pinSubmit = $("#discountPinSubmit", root);
      const msg = $("#discountMsg", root);
      const status = $("#discountStatus", root);
      const locked = $("#discountLocked", root);
      const unlocked = $("#discountUnlocked", root);
      const modeSel = $("#discountMode", root);
      const valInput = $("#discountValue", root);

      // If the section markup isn't present, do nothing
      if (!unlockBtn || !status) return;

      // Restore from sessionStorage (per-tab)
      try {
        const raw = sessionStorage.getItem("pm_discount_state_flite");
        if (raw) {
          const saved = JSON.parse(raw);
          if (saved && typeof saved === "object") {
            state.discount = {
              unlockedUntil: Number(saved.unlockedUntil || 0),
              mode: saved.mode === "fixed" ? "fixed" : "percent",
              value: Number(saved.value || 0),
            };
          }
        }
      } catch (e) {}

      const persist = () => {
        try {
          sessionStorage.setItem(
            "pm_discount_state_flite",
            JSON.stringify({
              unlockedUntil: state.discount?.unlockedUntil || 0,
              mode: state.discount?.mode || "percent",
              value: state.discount?.value || 0,
            })
          );
        } catch (e) {}
      };

      const isUnlocked = () => Date.now() < (state.discount?.unlockedUntil || 0);

      const setUnlockedUI = (ok) => {
        status.textContent = ok ? "Sbloccato" : "Bloccato";
        if (locked) locked.style.display = ok ? "none" : "block";
        if (unlocked) unlocked.style.display = ok ? "block" : "none";
      };

      // initial paint
      setUnlockedUI(isUnlocked());
      if (modeSel) modeSel.value = state.discount?.mode || "percent";
      if (valInput) valInput.value = String(state.discount?.value || 0);

      unlockBtn.addEventListener("click", () => {
        if (pinRow) {
          const isHidden = !pinRow.style.display || pinRow.style.display === "none";
          pinRow.style.display = isHidden ? "flex" : "none";
        }
        if (msg) msg.textContent = "";
        setTimeout(() => {
          try {
            pinInput?.focus();
          } catch (e) {}
        }, 30);
      });

      const doUnlock = () => {
        const entered = String(pinInput?.value || "").trim();
        if (entered !== CONFIG.discountPin) {
          if (msg) msg.textContent = "PIN non valido.";
          return;
        }

        // Unlock 15 minutes
        state.discount.unlockedUntil = Date.now() + 15 * 60 * 1000;
        if (msg) msg.textContent = "Sconto sbloccato (15 minuti).";
        persist();
        setUnlockedUI(true);
        renderSummary();
      };

      if (pinSubmit) pinSubmit.addEventListener("click", doUnlock);
      if (pinInput)
        pinInput.addEventListener("keydown", (e) => {
          if (e.key === "Enter") doUnlock();
        });

      if (modeSel)
        modeSel.addEventListener("change", () => {
          state.discount.mode = modeSel.value === "fixed" ? "fixed" : "percent";
          persist();
          renderSummary();
        });

      if (valInput)
        valInput.addEventListener("input", () => {
          const n = Number(valInput.value || 0);
          state.discount.value = Number.isFinite(n) ? n : 0;
          persist();
          renderSummary();
        });

      setInterval(() => {
        const ok = isUnlocked();
        setUnlockedUI(ok);
        if (!ok && (state.discount?.value || 0) !== 0) {
          state.discount.value = 0;
          persist();
          renderSummary();
        }
      }, 30000);
    }

    // =========================
    // ACTIONS
    // =========================
    function selectModel(modelId) {
      const m = MODELS.find((x) => x.id === modelId);
      if (!m) return;

      state.modelId = modelId;
      if (modelId === "icon") {
        state.iconSel = iconDefaultSelection();
      }
      state.variantKey = (m.variants && m.variants[0] && m.variants[0].key) || state.variantKey;

      // Reset extra list per modello (ogni configuratore ha i suoi accessori)
      state.accessories = buildAccessoriesForModel(modelId);

      updateMainImageForSelection();

      renderModelCards();
      renderVariantChoices();
      renderGallery();
      renderAccessories();
      renderSummary();
    }

    function selectVariant(variantKey) {
      if (state.modelId === "icon") {
        // ICON uses stepper selections; ignore generic variant switching.
        return;
      }
      state.variantKey = variantKey;
      updateMainImageForSelection();
      renderVariantChoices();
      renderSummary();
    }

    // =========================
    // PRINT QUOTE (iframe, no popup blocker)
    // =========================
    function printQuote() {
      const code = quoteCode();
      const m = currentModel();
      const v = currentVariant();

      const selectedAcc = state.accessories.filter((a) => a.checked);
      const totalCents = computeTotalCents();
      const originalCents = computeTotalCentsOriginal();
      const hasDiscount = totalCents < originalCents;

      const base = baseGrossCents();
      const discCents = computeDiscountCents(base);
      const baseAfter = Math.max(0, base - discCents);

      const accLines = selectedAcc.length
        ? selectedAcc
            .slice(0, 12)
            .map((a) => `- ${a.title}`)
            .join("\n")
        : "- Nessuno";

      const waText = encodeURIComponent(
        `Ciao! Ti invio i dettagli del preventivo (PDF in allegato).\n` +
          `Codice: ${code}\n` +
          `Modello: ${m.label}\n` +
          `Configurazione: ${v.title}\n` +
          `Extra:\n${accLines}\n` +
          (hasDiscount
            ? `Totale: ${money(originalCents)}\nSconto: -${money(originalCents - totalCents)}\nTotale scontato: ${money(totalCents)}\n`
            : `Totale: ${money(totalCents)}\n`) +
          `Validità fiera: fino al ${CONFIG.fairValidUntil}.`
      );

      const waHref = `https://wa.me/${CONFIG.whatsappNumber}?text=${waText}`;
      const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(
        waHref
      )}`;

      const LOGO_URL =
        "https://passionmarinenapoli.com/cdn/shop/files/PASSION_ORO_LUCIDO_3_48118ea1-0db4-4f71-a7c7-0b0d83e6e48a.png?v=1736436793&width=700";
      const COMPANY = {
        name: "Passion Marine Napoli",
        site: "passionmarinenapoli.com",
        whatsapp: "+39 342 348 8673",
      };

      const modelRow = `
        <tr>
          <td>
            <b>${m.label}</b>
            <div class="muted2">Configurazione: ${v.title}</div>
          </td>
          <td>
            <div class="pill2">Base</div>
          </td>
          <td style="text-align:right"><b>${money(baseAfter)}</b></td>
        </tr>
      `;

      const discountRow =
        discCents > 0
          ? `
        <tr>
          <td>
            <b>Sconto fiera</b>
            <div class="muted2">Applicato solo al prezzo base</div>
          </td>
          <td>
            <div class="pill2">Sconto</div>
          </td>
          <td style="text-align:right"><b>-${money(discCents)}</b></td>
        </tr>
      `
          : "";

      const accRows = selectedAcc
        .map(
          (a) => `
          <tr>
            <td>
              <b>${a.title}</b>
              ${a.desc ? `<div class="muted2">${a.desc}</div>` : ""}
            </td>
            <td>
              <div class="pill2">${a.category || "Extra"}</div>
            </td>
            <td style="text-align:right">${money(a.grossCents)}</td>
          </tr>
        `
        )
        .join("");

      const html = `
<!doctype html>
<html lang="it">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width,initial-scale=1" />
  <title>Preventivo FLITE | ${COMPANY.name}</title>
  <style>
    :root{ --line:#e9e9e9; --muted:#666; }
    body{ font-family: Arial, Helvetica, sans-serif; padding:24px; color:#111; }
    .top{ display:flex; justify-content:space-between; gap:16px; align-items:flex-start; }
    .rightCol{ display:flex; flex-direction:column; align-items:flex-end; gap:12px; }
    .qrBox{ display:flex; flex-direction:column; align-items:center; gap:6px; padding:10px; border:1px solid var(--line); border-radius:12px; background:#fff; }
    .qrLabel{ font-size:12px; color:var(--muted); }
    .qrImg{ width:180px; height:180px; object-fit:contain; display:block; }
    .qrHint{ font-size:12px; color:var(--muted); }
    .brand{ display:flex; gap:12px; align-items:flex-start; }
    .logo{ width:140px; height:auto; }
    h1{ margin:0 0 6px; font-size:20px; }
    .muted{ color:var(--muted); font-size:12px; line-height:1.4; }
    .muted2{ color:var(--muted); font-size:12px; line-height:1.35; margin-top:4px; }
    .meta{ display:flex; gap:10px; flex-wrap:wrap; margin-top:6px; }
    .tag{ border:1px solid var(--line); border-radius:999px; padding:6px 10px; font-size:12px; color:var(--muted); background:#fff; }
    table{ width:100%; border-collapse:collapse; margin-top:14px; }
    th,td{ border-bottom:1px solid var(--line); padding:10px 8px; font-size:13px; vertical-align:top; }
    th{ text-align:left; background:#fafafa; font-size:12px; text-transform:uppercase; letter-spacing:.02em; color:var(--muted); }
    .total{ margin-top:14px; display:flex; justify-content:flex-end; }
    .totalBox{ border:1px solid var(--line); padding:10px 12px; border-radius:10px; background:#fff; }
    .totalBox b{ font-size:18px; }
    .pill2{ display:inline-block; border:1px solid var(--line); border-radius:999px; padding:4px 8px; font-size:12px; color:var(--muted); background:#fff; }
    .space{ height:10px; }

    @media print{
      body{ padding:16px; }
      th{ -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    }
  </style>
</head>
<body>
  <div class="top">
    <div>
      <div class="brand">
        <img class="logo" src="${LOGO_URL}" alt="${COMPANY.name}" />
        <div>
          <h1>Preventivo FLITE</h1>
          <div class="muted">${COMPANY.name}</div>
          <div class="muted">Sito: ${COMPANY.site} · WhatsApp: ${COMPANY.whatsapp}</div>
        </div>
      </div>
      <div class="meta">
        <div class="tag">Codice: <b>${code}</b></div>
        <div class="tag">Data: <b>${todayStr()}</b></div>
        <div class="tag">Prezzi: <b>IVA inclusa</b></div>
      </div>
    </div>

    <div class="rightCol">
      <div class="muted" style="text-align:right">
        Cliente: _______________________<br/>
        Telefono: ______________________<br/>
        Email: _________________________
      </div>

      <div class="qrBox">
        <div class="qrLabel">Scansiona per WhatsApp</div>
        <img class="qrImg" src="${qrSrc}" alt="QR WhatsApp" />
        <div class="qrHint">Preventivo: <b>${code}</b></div>
      </div>
    </div>
  </div>

  <table>
    <thead>
      <tr>
        <th>Articolo</th>
        <th>Categoria</th>
        <th style="text-align:right">Prezzo (IVA incl.)</th>
      </tr>
    </thead>
    <tbody>
      ${modelRow}
      ${discountRow}
      ${accRows}
    </tbody>
  </table>

  <div class="total">
    <div class="totalBox">Totale (IVA incl.): <b>${money(totalCents)}</b></div>
  </div>

  <div class="space"></div>
  <div class="muted">Nota: prezzi indicativi soggetti a disponibilità e configurazione finale. Per conferma e tempi, contattaci su WhatsApp indicando il codice preventivo (oppure scansiona il QR).</div>
</body>
</html>`;

      // Print via hidden iframe (avoids popup blockers)
      let iframe = document.getElementById("pmQuotePrintFrame");
      if (!iframe) {
        iframe = document.createElement("iframe");
        iframe.id = "pmQuotePrintFrame";
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        document.body.appendChild(iframe);
      }

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();

      const tryPrint = () => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (e) {
          console.error(e);
          alert("Impossibile avviare la stampa. Controlla le impostazioni del browser.");
        }
      };

      const waitImagesThenPrint = () => {
        const imgs = Array.from(iframe.contentWindow.document.images || []);
        if (!imgs.length) return tryPrint();
        const pending = imgs.filter((im) => !im.complete);
        if (!pending.length) return tryPrint();

        let left = pending.length;
        const done = () => {
          left -= 1;
          if (left <= 0) tryPrint();
        };
        pending.forEach((im) => {
          im.addEventListener("load", done, { once: true });
          im.addEventListener("error", done, { once: true });
        });

        setTimeout(tryPrint, 800);
      };

      setTimeout(waitImagesThenPrint, 250);
    }

    // =========================
    // BUTTONS + EVENTS
    // =========================
    const btnMain = $("#ctaAdd", root);
    if (btnMain) {
      btnMain.textContent = "Stampa preventivo";
      btnMain.addEventListener("click", printQuote);
    }

    const btnTop = $("#ctaAddTop", root);
    if (btnTop) {
      btnTop.textContent = "Stampa preventivo";
      btnTop.addEventListener("click", printQuote);
    }

    const btnBottom = $("#ctaAddBottom", root);
    if (btnBottom) {
      btnBottom.textContent = "Stampa preventivo";
      btnBottom.addEventListener("click", printQuote);
    }

    // =========================
    // BOOT
    // =========================
    renderModelCards();
    renderVariantChoices();
    renderGallery();
    renderAccessories();
    initDiscountUI();
    renderSummary();

    // Default bind on static cards if present
    $$(".modelCard", root).forEach((card) => {
      const id = card.dataset.model;
      if (!id) return;
      if (card.dataset.bound === "1") return;
      card.dataset.bound = "1";
      card.addEventListener("click", () => selectModel(id));
      card.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") selectModel(id);
      });
    });

    // Force initial selection
    selectModel(state.modelId);
  });
})();